import React from "react";
import { Link } from "react-router-dom";

import "../../Styles/Registerprofile.css";

const Registerprofile = () => {
    return (
        <div className="Registerprofile">
            <div className="Registerprofile-inside">
                <div className="Registerprofile-inside-item1">
                    <img
                        className="Registerprofile-inside-item1-img"
                        src="imgs/Profile/Registerprofile.svg"
                    />
                </div>
                <div className="Registerprofile-inside-item2">
                    <p className="Registerprofile-inside-item2-text">
                        هنوز تو کتابنو ثبت نام نکردی!
                    </p>
                </div>
                <div className="Registerprofile-inside-item3">
                    <Link
                        to="/login"
                        className="Registerprofile-inside-item3-link"
                    >
                        ورود
                    </Link>
                </div>
            </div>
        </div>
    );
};
export default Registerprofile;
